import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-cream px-6">
      <motion.div
        initial={{ opacity: 0, y: 25 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-xl text-center"
      >
        <p className="text-sm font-bold uppercase tracking-[0.25em] text-hotpink">
          Error 404
        </p>

        <h1 className="mt-5 font-display text-7xl font-black tracking-tight">
          Page not found
        </h1>

        <p className="mt-6 text-lg text-ink/60">
          The page you're looking for doesn't exist or may have been moved.
        </p>

        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="cta-glow inline-flex items-center gap-2 rounded-full bg-sunset-gradient px-7 py-3 font-semibold text-white"
          >
            <Home size={18} />
            Back Home
          </Link>

          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 rounded-full border border-ink/15 bg-white px-7 py-3 font-semibold text-ink hover:bg-ink/5"
          >
            <ArrowLeft size={18} />
            Go Back
          </button>
        </div>
      </motion.div>
    </div>
  );
}